"use client";
import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import Image from "next/image";
import NextLink from "next/link";
import { IMAGES } from "../constants/images";
import { useTranslation } from "react-i18next";

const Banner = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const [offerData, setOfferData] = useState({
    allSpots: "...",
    takenSpots: "...",
    remainingSpots: "...",
    discountPercentage: "...",
  });

  useEffect(() => {
    console.log("Banner component mounted!");

    const checkData = () => {
      const activeOffers = localStorage.getItem("activeOffers");
      console.log("Checking localStorage:", activeOffers);

      if (activeOffers) {
        try {
          const parsedData = JSON.parse(activeOffers);
          console.log("Parsed data:", parsedData);

          if (parsedData.success && parsedData.data) {
            const data = {
              allSpots: parsedData.data.allSpots,
              takenSpots: parsedData.data.takenSpots,
              remainingSpots: parsedData.data.remainingSpots,
              discountPercentage: parsedData.data.discountPercentage,
            };
            console.log("Setting offer data:", data);
            setOfferData(data);
            return true;
          }
        } catch (error) {
          console.error("Error parsing data:", error);
        }
      }
      return false;
    };

    checkData();

    const interval = setInterval(() => {
      const success = checkData();
      if (success) {
        clearInterval(interval);
      }
    }, 300);

    setTimeout(() => clearInterval(interval), 10000);

    return () => clearInterval(interval);
  }, []);

  console.log("Banner rendering, offerData:", offerData);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        py: 2,
        px: 2,
        mt: { xs: "3%", sm: "4%", md: "-2%" },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          backgroundColor: "#B07FF8",
          borderRadius: "50px",
          px: 3,
          py: 2,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Typography
          sx={{
            flex: 1,
            color: "#FFFFFF",
            fontSize: { xs: "0.85rem", md: "1rem" },
            fontWeight: 500,
            fontFamily: "var(--font-outfit), 'Inter', sans-serif",
            textAlign: isArabic ? "right" : "left",
          }}
        >
          {t("banner.warning", {
            allSpots: offerData.allSpots,
            discountPercentage: offerData.discountPercentage,
            takenSpots: offerData.takenSpots,
            remainingSpots: offerData.remainingSpots,
          })}
        </Typography>

        <Button
          component={NextLink}
          href="/founding-member-of-recruitment-automation-software"
          sx={{
            backgroundColor: "#FFFFFF",
            color: "#9048FB",
            fontWeight: 600,
            fontSize: "0.9rem",
            minWidth: "170px",
            fontFamily: "var(--font-outfit), 'Inter', sans-serif",
            display: "flex",
            alignItems: "center",
            flexDirection: isArabic ? "row-reverse" : "row",
            gap: 1,
            textTransform: "none",
            borderRadius: "50px",
            px: 3,
            py: 1.2,
            "&:hover": {
              backgroundColor: "#FFFFFF",
              transform: "scale(1.05)",
            },
          }}
        >
          <Image
            src={IMAGES.EYES_GIF}
            alt="eyes"
            width={24}
            height={24}
            style={{ objectFit: "contain" }}
            priority
          />
          {t("banner.claimSpot")}
        </Button>
      </Box>
    </Box>
  );
};

export default Banner;